
const digest = '1afca6ba324ad823c7c56d6e7c93f2eb2fac274a58e41ba9fa3caf3ef5833a38';
const classes = {"wrapper":"_wrapper_1cwcy_1","header":"_header_1cwcy_9","left":"_left_1cwcy_15","date":"_date_1cwcy_22","name":"_name_1cwcy_27","draftBadge":"_draftBadge_1cwcy_33","meta":"_meta_1cwcy_42","diagnosis":"_diagnosis_1cwcy_47","diagnosisLabel":"_diagnosisLabel_1cwcy_51","textBlock":"_textBlock_1cwcy_56","text":"_text_1cwcy_56","textCollapsed":"_textCollapsed_1cwcy_70","textToggle":"_textToggle_1cwcy_75","textToggleLink":"_textToggleLink_1cwcy_79"};
const css = `._wrapper_1cwcy_1 {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  font-family: Rubik, sans-serif;
}

._header_1cwcy_9 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
._header_1cwcy_9 ._left_1cwcy_15 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

._date_1cwcy_22 {
  font-size: 12px;
  font-weight: 600;
}

._name_1cwcy_27 {
  color: #000000;
  font-weight: 500;
  font-size: 14px;
}

._draftBadge_1cwcy_33 {
  background-color: #fef3c7;
  color: #92400e;
  border-radius: 4px;
  padding: 1px 6px;
  font-size: 12px;
  font-weight: 500;
}

._meta_1cwcy_42 {
  color: #9ca3af;
  font-size: 12px;
}

._diagnosis_1cwcy_47 {
  font-size: 12px;
}

._diagnosisLabel_1cwcy_51 {
  color: #6b7280;
  margin-right: 4px;
}

._textBlock_1cwcy_56 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

._text_1cwcy_56 {
  color: #374151;
  line-height: 1.4;
  word-break: break-word;
  font-size: 12px;
}

._textCollapsed_1cwcy_70 {
  overflow: hidden;
  max-height: 2.8em;
}

._textToggle_1cwcy_75 {
  flex-shrink: 0;
}

._textToggleLink_1cwcy_79 {
  font-size: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  